import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function MoneyDollar({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>MoneyDollar</title>
      <g clipPath="url(#clip0_3458_6448)">
        <rect
          x="2"
          y="6"
          width="20"
          height="12"
          stroke={color ?? 'currentColor'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22 10C21.4747 10 20.9546 9.89654 20.4693 9.69552C19.984 9.4945 19.543 9.19986 19.1716 8.82843C18.8001 8.45699 18.5055 8.01604 18.3045 7.53073C18.1035 7.04543 18 6.52529 18 6L22 6L22 10Z"
          stroke={color ?? 'currentColor'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 18C18 16.9391 18.4214 15.9217 19.1716 15.1716C19.9217 14.4214 20.9391 14 22 14L22 18L18 18Z"
          stroke={color ?? 'currentColor'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 14C3.06087 14 4.07828 14.4214 4.82843 15.1716C5.57857 15.9217 6 16.9391 6 18L2 18L2 14Z"
          stroke={color ?? 'currentColor'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 6C6 7.06087 5.57857 8.07828 4.82843 8.82843C4.07828 9.57857 3.06087 10 2 10L2 6H6Z"
          stroke={color ?? 'currentColor'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.0741 10.25C14.4883 10.25 14.8241 9.91421 14.8241 9.5C14.8241 9.08579 14.4883 8.75 14.0741 8.75V10.25ZM10 13.75C9.58579 13.75 9.25 14.0858 9.25 14.5C9.25 14.9142 9.58579 15.25 10 15.25V13.75ZM14.0741 8.75H11.3333V10.25H14.0741V8.75ZM11.3333 12.75H13.1111V11.25H11.3333V12.75ZM13.1111 13.75H10V15.25H13.1111V13.75ZM13.6944 13.25C13.6944 13.4813 13.4796 13.75 13.1111 13.75V15.25C14.2154 15.25 15.1944 14.3994 15.1944 13.25H13.6944ZM13.1111 12.75C13.4796 12.75 13.6944 13.0187 13.6944 13.25H15.1944C15.1944 12.1006 14.2154 11.25 13.1111 11.25V12.75ZM9.25 10.75C9.25 11.8994 10.2291 12.75 11.3333 12.75V11.25C10.9648 11.25 10.75 10.9813 10.75 10.75H9.25ZM11.3333 8.75C10.2291 8.75 9.25 9.60057 9.25 10.75H10.75C10.75 10.5187 10.9648 10.25 11.3333 10.25V8.75Z"
          fill={color ?? 'currentColor'}
        />
        <path
          d="M12 9.51733V8.5"
          stroke={color ?? 'currentColor'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 15.5173V14.5"
          stroke={color ?? 'currentColor'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3458_6448">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
